import { render, staticRenderFns } from "./PolicyUpdate.vue?vue&type=template&id=4653a984&"
import script from "./PolicyUpdate.vue?vue&type=script&lang=js&"
export * from "./PolicyUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports